export default {
  magazine: [],
}
